export default {
  magazine: [],
}
